const styles = theme => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: theme.spacing(10),
    "@supports (height: constant(safe-area-inset-bottom))": {
      "--safe-area-inset-bottom": "constant(safe-area-inset-bottom)",
      height: `calc(${theme.spacing(10)}px + var(--safe-area-inset-bottom))`,
      paddingBottom: "var(--safe-area-inset-bottom)"
    },
    "@supports (height: env(safe-area-inset-bottom))": {
      "--safe-area-inset-bottom": "env(safe-area-inset-bottom)",
      height: `calc(${theme.spacing(10)}px + var(--safe-area-inset-bottom))`,
      paddingBottom: "var(--safe-area-inset-bottom)"
    },
    background: "#EFF6EE",
    // overflow: "hidden",
    boxShadow: `${theme.spacing(0)}px ${theme.spacing(-0.5)}px ${theme.spacing(
      0.5
    )}px rgba(0, 0, 0, 0.16)`,
    "& button": {
      height: "100%"
    }
  },
  createContainer: {
    position: "relative",
    bottom: 105,
    right: 0,
    [theme.breakpoints.up("lg")]: {
      right: "10%"
    },
    [theme.breakpoints.down("md")]: {
      right: "5%"
    },
    [theme.breakpoints.down("sm")]: {
      right: 20
    }
  },
  fabContainer: {
    transform: "translate3d(0,0,0)",

    height: "45px",
    width: "45px",
    position: "fixed",
    right: "10%",
    [theme.breakpoints.down("lg")]: {
      right: "4%"
    },
    [theme.breakpoints.down("md")]: {
      right: "10px"
    },
    [theme.breakpoints.down("sm")]: {
      right: "10px"
    }
  },

  addButton: {
    transform: "translate3d(0,0,0)",
    position: "fixed",
    height: "40px",
    width: "40px",
    fontSize: 60,
    color: "white",
    fontWeight: 700
  },
  addButtonDisabled: {
    color: "#999"
  },
  starIcon: {
    fontSize: 30,
    color: theme.palette.primary.light
  },
  checkIcon: {
    fontSize: 22,
    color: theme.palette.primary.light
  },
  homeIcon: {
    fontSize: 28,
    color: theme.palette.primary.light
  },
  bottomNavIcon: {
    fontSize: 32
  },
  file: {
    visibility: "hidden"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/BottomNav/styles.js